import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteOrgStructureItem as apiDelete } from "../../api/apiOrgStructureItems";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useDeleteOrgStructureItem() {
    const qc = useQueryClient(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: deleteOrgStructureItem, isPending: isDelete } = useMutation({
        mutationFn: (id) => apiDelete(id),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); qc.invalidateQueries({ queryKey: ["orgStructureItems"] }); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); },
    });
    return { deleteOrgStructureItem, isDelete };
}
